// MARQUEE POWER-UP
window.addEventListener("DOMContentLoaded", (event) => {
  // attribute value checker
  function attr(defaultVal, attrVal) {
    const defaultValType = typeof defaultVal;
    if (typeof attrVal !== "string" || attrVal.trim() === "") return defaultVal;
    if (attrVal === "true" && defaultValType === "boolean") return true;
    if (attrVal === "false" && defaultValType === "boolean") return false;
    if (isNaN(attrVal) && defaultValType === "string") return attrVal;
    if (!isNaN(attrVal) && defaultValType === "number") return +attrVal;
    return defaultVal;
  }
  // marquee component
  $("[tr-marquee-element='component']").each(function (index) {
    let componentEl = $(this),
      panelEl = componentEl.find("[tr-marquee-element='panel']"),
      triggerHoverEl = componentEl.find("[tr-marquee-element='triggerhover']"),
      triggerClickEl = componentEl.find("[tr-marquee-element='triggerclick']");
    let speedSetting = attr(100, componentEl.attr("tr-marquee-speed")),
      verticalSetting = attr(false, componentEl.attr("tr-marquee-vertical")),
      reverseSetting = attr(false, componentEl.attr("tr-marquee-reverse")),
      scrollDirectionSetting = attr(
        false,
        componentEl.attr("tr-marquee-scrolldirection")
      ),
      scrollScrubSetting = attr(
        false,
        componentEl.attr("tr-marquee-scrollscrub")
      ),
      moveDistanceSetting = -100,
      timeScaleSetting = 1,
      pausedStateSetting = false;
    if (reverseSetting) moveDistanceSetting = 100;
    let marqueeTimeline = gsap.timeline({
      repeat: -1,
      onReverseComplete: () => marqueeTimeline.progress(1),
    });
    if (verticalSetting) {
      speedSetting = panelEl.first().height() / speedSetting;
      marqueeTimeline.fromTo(
        panelEl,
        { yPercent: 0 },
        { yPercent: moveDistanceSetting, ease: "none", duration: speedSetting }
      );
    } else {
      speedSetting = panelEl.first().width() / speedSetting;
      marqueeTimeline.fromTo(
        panelEl,
        { xPercent: 0 },
        { xPercent: moveDistanceSetting, ease: "none", duration: speedSetting }
      );
    }
    let scrubObject = { value: 1 };
    ScrollTrigger.create({
      trigger: "body",
      start: "top top",
      end: "bottom bottom",
      onUpdate: (self) => {
        if (!pausedStateSetting) {
          if (scrollDirectionSetting && timeScaleSetting !== self.direction) {
            timeScaleSetting = self.direction;
            marqueeTimeline.timeScale(self.direction);
          }
          if (scrollScrubSetting) {
            let v = self.getVelocity() * 0.006;
            v = gsap.utils.clamp(-60, 60, v);
            let scrubTimeline = gsap.timeline({
              onUpdate: () => marqueeTimeline.timeScale(scrubObject.value),
            });
            scrubTimeline.fromTo(
              scrubObject,
              { value: v },
              { value: timeScaleSetting, duration: 0.5 }
            );
          }
        }
      },
    });
    function pauseMarquee(isPausing) {
      pausedStateSetting = isPausing;
      let pauseObject = { value: 1 };
      let pauseTimeline = gsap.timeline({
        onUpdate: () => marqueeTimeline.timeScale(pauseObject.value),
      });
      if (isPausing) {
        pauseTimeline.fromTo(
          pauseObject,
          { value: timeScaleSetting },
          { value: 0, duration: 0.5 }
        );
        triggerClickEl.addClass("is-paused");
      } else {
        pauseTimeline.fromTo(
          pauseObject,
          { value: 0 },
          { value: timeScaleSetting, duration: 0.5 }
        );
        triggerClickEl.removeClass("is-paused");
      }
    }
    if (window.matchMedia("(pointer: fine)").matches) {
      triggerHoverEl.on("mouseenter", () => pauseMarquee(true));
      triggerHoverEl.on("mouseleave", () => pauseMarquee(false));
    }
    triggerClickEl.on("click", function () {
      !$(this).hasClass("is-paused") ? pauseMarquee(true) : pauseMarquee(false);
    });
  });
});

// ANNOUNCEMENT CLOSE DESKTOP
$(document).ready(function () {
  $(".announcement-close").click(function () {
    // Obtém o valor do atributo data-target
    var target = $(this).data("target");
    // Esconde a div correspondente ao seletor
    $(target).hide();
  });
});

// NAV MENU
$(document).ready(function () {
  // Toggle main menu
  $("#hamburger").click(function () {
    $("#nav-links").stop().slideToggle(300);
  });

  // Toggle dropdown menus
  $(".nav-links > li > a").click(function (e) {
    const isMobile = window.innerWidth <= 768; // Apenas no mobile
    if (isMobile) {
      e.preventDefault(); // Impede o redirecionamento
      $(this).next(".dropdown").stop().slideToggle(300);
    }
  });

  // Hover dropdowns no desktop
  $(".nav-links > li").hover(
    function () {
      if (window.innerWidth > 768) {
        $(this).find(".dropdown").stop().slideDown(300);
      }
    },
    function () {
      if (window.innerWidth > 768) {
        $(this).find(".dropdown").stop().slideUp(300);
      }
    }
  );
});

// HEADER DROP DOWN
$(document).ready(function () {
  $(".dropdown-button").click(function () {
    $(".dropdown-menu").toggle(); // Alterna entre mostrar/ocultar o menu
  });

  $(".dropdown2").click(function () {
    $(this).toggleClass("active"); // Adiciona ou remove a classe 'active' ao clicar
  });

  // Ocultar o menu ao clicar fora dele
  $(document).click(function (event) {
    if (!$(event.target).closest(".dropdown2, .dropdown-menu").length) {
      $(".dropdown-menu").hide();
      $(".dropdown2").removeClass("active"); // Remove a classe 'active' ao clicar fora
    }
  });
});

// COUNTDOWN
// function startCountdown() {
//   var endDate = new Date(); // Preencha com a data final do countdown
//   endDate.setSeconds(endDate.getSeconds() + 287200); // Change the date in seconds

//   setInterval(function () {
//     var now = new Date();
//     var timeLeft = endDate - now;

//     var days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
//     var hours = Math.floor(
//       (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
//     );
//     var minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
//     var seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

//     $(".countdown .days").text(days);
//     $(".countdown .hours").text(hours);
//     $(".countdown .minutes").text(minutes);
//     $(".countdown .seconds").text(seconds);

//     if (timeLeft < 0) {
//       // Quando o countdown atingir 0, atualize a data final para iniciar novamente
//       endDate = new Date();
//       endDate.setSeconds(endDate.getSeconds() + 60); // Adiciona 60 segundos para reiniciar o countdown
//     }
//   }, 1000); // Atualiza a cada segundo
// }

// $(document).ready(function () {
//   startCountdown();
// });

// PRODUCT HERO ACCORDION
$(document).ready(function () {
  $(".accordion-header").click(function () {
    const content = $(this).next(".accordion-content");
    const icon = $(this).find(".accordion-icon img");

    if (content.is(":visible")) {
      content.slideUp(300); // Close accordion
      icon.attr("src", "img/plus-icon.svg");
    } else {
      content.slideDown(300); // Open accordion
      icon.attr("src", "img/close-icon.svg");
    }
  });
});

// COLLECTION FILTER DROPDOWN
$(document).ready(function () {
  // Toggle the dropdown menu
  $(".dropdown-selected").on("click", function () {
    const menu = $(this).siblings(".dropdown-menu3");
    const arrow = $(this).find(".arrow");

    // Toggle the menu and arrow
    if (menu.is(":visible")) {
      menu.slideUp(200);
      arrow.css("transform", "rotate(0deg)"); // Reset arrow
    } else {
      menu.slideDown(200);
      arrow.css("transform", "rotate(180deg)"); // Rotate arrow
    }
  });

  // Select an option
  $(".dropdown-menu3 li").on("click", function () {
    const selectedText = $(this).text();
    const selectedValue = $(this).data("value");

    // Update the selected text
    // $(this).parent().siblings('.dropdown-selected').contents().first()[0].textContent = selectedText;

    // Close the dropdown menu
    $(this).parent().slideUp(200);

    // Reset the arrow
    $(this)
      .parent()
      .siblings(".dropdown-selected")
      .find(".arrow")
      .css("transform", "rotate(0deg)");

    // Optional: Handle the selected value
    console.log("Selected value:", selectedValue);
  });

  // Close dropdown when clicking outside
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".dropdown3").length) {
      $(".dropdown-menu3").slideUp(200);
      $(".arrow").css("transform", "rotate(0deg)"); // Reset all arrows
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const playButtons = document.querySelectorAll(".play-video");
  const mobileVideos = document.querySelectorAll(".mobile-video");

  playButtons.forEach((playButton, index) => {
    const mobileVideo = mobileVideos[index];

    if (playButton && mobileVideo) {
      playButton.addEventListener("click", function (event) {
        event.preventDefault();
        mobileVideo.style.display = "block";
        mobileVideo.play();
        this.style.display = "none";
        document.querySelectorAll(".video-wrap-mobile")[
          index
        ].style.backgroundImage = "none";
        document.querySelectorAll(".video-wrap-mobile")[index].style.minHeight =
          "1px";
      });
    }
  });
});
